import { render, staticRenderFns } from "./productPaperwork.vue?vue&type=template&id=2ff9a3a4&scoped=true&"
import script from "./productPaperwork.vue?vue&type=script&lang=js&"
export * from "./productPaperwork.vue?vue&type=script&lang=js&"
import style0 from "./productPaperwork.vue?vue&type=style&index=0&id=2ff9a3a4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9a3a4",
  null
  
)

export default component.exports